var map = {
	"./core/css-variables": 1887,
	"./core/lozad": 5748,
	"./core/polyfills": 9565,
	"./navigation/banner": 7873,
	"./navigation/mobile": 3913,
	"./navigation/scroll": 6693,
	"./posts/animation": 6891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1058;